import React, {useState} from 'react'
import styles from './newtwo.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faDownLong, faLock, faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import Payonline from '../../../src/assets/images/icon/onlinepay.svg'

const Newtwo = () => {
     const [openJobs, setOpenJobs] = useState(false);
      const [openInternships, setOpenInternships] = useState(false);
      const [openAdmin, setOpenAdmin] = useState(false);
      const [isRightbarExpanded, setRightbarExpanded] = useState(false);
    
      const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    
      const toggleSidebar = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
      };
      const toggleRightbar = () => {
        setRightbarExpanded((prev) => !prev);
      };
      const [activeTab, setActiveTab] = useState("manual");
      const searchItems = [
        {
          date: 'Oct 18, 2024',
          title: 'Next Js Developer with Node and Mongo DB Expertise and Can lead the team.',
        },
        {
          date: 'Oct 18, 2024',
          title: 'Next Js Developer with Node and Mongo DB Expertise and Can lead the team.',
        },
        {
          date: 'Oct 18, 2024',
          title: 'Next Js Developer with Node and Mongo DB Expertise and Can lead the team.',
        },
        {
          date: 'Oct 18, 2024',
          title: 'Next Js Developer with Node and Mongo DB Expertise and Can lead the team.',
        },
      ];
  return (
    <section>
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-8'>
                    <div className={`${styles['search-candidate']}`}>
                        <div className='row'>
                            <div className='col-md-12'>
                                <h3 className={`${styles['search-title']} text-center mb-4`}>Search Candidate</h3>
                                <hr/>
                                <ul className="nav nav-pills nav-justified mb-4">
                                    <li className="nav-item">
                                    <button
                                        className={`nav-search nav-link ${activeTab === "manual" ? "active" : ""}`}
                                        onClick={() => setActiveTab("manual")}
                                    >
                                        Search manually
                                    </button>
                                    </li>
                                    <li className="nav-item">
                                    <button
                                        className={`nav-search nav-link ${activeTab === "ai" ? "active" : ""}`}
                                        onClick={() => setActiveTab("ai")}
                                    >
                                        ✨ Use AI
                                    </button>
                                    </li>
                                </ul>
                                <div>
                                    {activeTab === "manual" && (
                                    <div>
                                        <form>
                                            <div className="mb-3">
                                            <label className={`${styles['ct-label']} form-lable`}>Searching for *</label>
                                            <div>
                                                <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="searchingFor" id="freshersOnly"/>
                                                <label className="form-check-label" htmlFor="freshersOnly">
                                                    Freshers only
                                                </label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="searchingFor" id="experiencedOnly"/>
                                                <label className="form-check-label" htmlFor="experiencedOnly">
                                                    Experienced only
                                                </label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                <input className="form-check-input"type="radio" name="searchingFor" id="both"/>
                                                <label className="form-check-label" htmlFor="both">
                                                    Both
                                                </label>
                                                </div>
                                            </div>
                                            </div>
                                            <div className="mb-3">
                                            <label htmlFor="keywords" className={`${styles['ct-label']} form-lable`}>
                                                Keywords *
                                            </label>
                                            <input type="text" className="form-control" id="keywords" placeholder="Enter keywords such as job title, skills, etc."/>
                                            </div>
                                            <div className="mb-3">
                                            <label htmlFor="presentCity" className={`${styles['ct-label']} form-lable`}>
                                                Present City *
                                            </label>
                                            <input type="text" className="form-control" id="presentCity" placeholder="Enter the city"/>
                                            </div>
                                            <div className="mb-3">
                                            <label className={`${styles['ct-label']} form-lable`}>Experience *</label>
                                            <div className="row">
                                                <div className="col">
                                                <input type="number" className="form-control" placeholder="Enter min year"/>
                                                </div>
                                                <div className="col">
                                                <input type="number" className="form-control" placeholder="Enter max years"/>
                                                </div>
                                            </div>
                                            </div>
                                            <div className="mb-3">
                                            <label className={`${styles['ct-label']} form-lable`}>Annual Salary *</label>
                                            <div className="row">
                                                <div className="col">
                                                <input type="number" className="form-control" placeholder="Select lower limit of salary"/>
                                                </div>
                                                <div className="col">
                                                <input type="number" className="form-control" placeholder="Select higher limit of salary"/>
                                                </div>
                                            </div>
                                            </div>
                                            <div className="mb-3">
                                            <label className={`${styles['ct-label']} form-lable`}>Education Qualifications</label>
                                            <div className="d-flex flex-wrap gap-2">
                                                {[
                                                "Class X", "Class XII", "ITI", "Diploma", "Bachelor's Degree", "Master Degree", "PhD",
                                                ].map((qualification) => (
                                                <button type="button" className={`${styles['select-edu']} btn`} key={qualification} > {qualification} + </button>
                                                ))}
                                            </div>
                                            </div>
                                            <div className="d-flex justify-content-end gap-2">
                                            <button type="reset" className={`${styles['reset-btn']} btn`}> Reset </button>
                                            <button type="submit" className={`${styles['search-btn']} btn`}> Search </button>
                                            </div>
                                        </form>
                                    </div>
                                    )}
                                    {activeTab === "ai" && (
                                    <div>
                                        <div className={`${styles['jobz-box']}`}>
        <h1 className={`${styles['hi-text']} mb-0 un-yellow`}>Hello I am <span className={`${styles['hi-title']} un-blue`}>JobZ <span className='un-yellow'>AI</span></span></h1>
        <p className={`${styles['jobz-info']}`}>
          Give me your requirement for hiring by simply writing or pasting and I’ll
          help you to set up the tailored search as per your need with the best
          matching profile to filter out from our database pool.
        </p>
      </div>

      <form className="mt-4">
        <div className="mb-3">
          <label htmlFor="jobDescription" className={`${styles['ct-label']} form-lable`}>Job Description:</label>
          <textarea
            id="jobDescription"
            className="form-control"
            rows="3"
            placeholder="Enter the job description here..."
            maxLength="500"
            required
          >
I need a Full stack developer having AI skills and also know some designing tools such as figma to collaborate with team members, should have at least 3-5 years of experience and should be available in Bangalore to join immediately.
          </textarea>
          <div className="text-end text-muted small">240/500 Characters Left</div>
        </div>

        <div className="mb-3">
          <label htmlFor="jobFile" className={`${styles['ct-label']} form-lable`}>Upload Job Description</label>
         <div className={`${styles['choose-box']} my-2`}>
         <input
            type="file"
            id="jobFile"
            className="form-control"
            accept=".pdf, .doc, .docx, .txt"
          />
          <div className="form-text">
            Only support PDF, Doc, Docx, TXT and files less than 5 MB.
          </div>
         </div>
        </div>

        <div className="text-center">
          <button type="submit" className="btn btn-primary">Browse Files</button>
        </div>
      </form>
      <div className="d-flex justify-content-end gap-2">
                                            <button type="reset" className={`${styles['reset-btn']} btn`}> Reset </button>
                                            <button type="submit" className={`${styles['search-btn']} btn`}> Search </button>
                                            </div>

                                    </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className={`${styles['card-credits']} p-3 mb-3 shadow-sm`}>
                        <h5 className={`${styles['credits-title']} mb-3`}>How Database Credit Works?</h5>
                        <ul className="list-unstyled">
                            <li className="mb-2">
                            <span className={`${styles['lock-icon']} me-2`}>
                                <FontAwesomeIcon icon={faLock}/>
                            </span>
                            <span className={`${styles['text-profile']}`}>1 Profile Unlock = 1 Database Credit</span>
                            </li>
                            <li className="mb-2">
                            <span className={`${styles['download-icon']} me-2`}>
                                <FontAwesomeIcon icon={faDownload}/>
                            </span>
                            <span className={`${styles['text-profile']}`}>1 Excel Download = 2 Database Credits</span>
                            </li>
                        </ul>
                        <p className={`${styles['list-paragraph']}`}>
                            For already unlocked profiles, only 1 Database credit will be required
                            for Excel Download
                        </p>
                        <div className={`${styles['credit-box']} text-center p-3`}>
                            <div className={`${styles['plan-text']}`}>
                            <img src={Payonline} className='pe-2'/>Explore Best Plans and Offers
                            </div>
                            <br />
                            <button className={`${styles['search-btn']} btn w-100`}>
                            Buy Credits<FontAwesomeIcon className='ps-2' icon={faLongArrowAltRight}/>
                            </button>
                        </div>
                    </div>
                    <div className={`${styles['card-credits']} p-3 mb-3 shadow-sm`}>
                        <div className="card-header bg-white d-flex justify-content-between align-items-center">
                        <h5 className={`${styles['credits-title']}`}>Search History</h5>
                        <a href="#see-all" className={`${styles['see-all']}`}>
                            See All
                        </a>
                        </div>
                        <hr className='mt-0'/>
                        <div className={`${styles['main-box']} list-group list-group-flush`}>
                        {searchItems.map((item, index) => (
                            <div key={index} className={`${styles['job-card']}`}>
                            <div className={`${styles['date-badge']}`}>{item.date}</div>
                            <div className={`${styles['job-info']}`}>
                                <span>{item.title}</span>
                                <div className={`${styles['link-badge']}`}>
                                    <a href='#' className={`${styles['fill-badge']}`}>Fill search</a>
                                    <a href='#' className={`${styles['search-badge']}`}>Search Candidate</a>
                                </div>
                            </div>
                            </div>
                        ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Newtwo